<div class="tag-manager-page">
  <h2 class="tag-manager-page__header h1">Tags Directory</h2>
  <div class="tag-manager-page__controls">
    <form [formGroup]="form" class="tag-manager-page__filters">
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Search tags</mat-label>
        <mat-icon matPrefix class="me-2">search</mat-icon>
        <input matInput [formControlName]="'name'" placeholder="Type to filter tags...">
      </mat-form-field>
      @if (isManager) {
      <button (click)="openCreateTagDialog('0ms','0ms')" mat-flat-button>Create Tag</button>
      }
    </form>
  </div>

  @if (isManager) {
  <button mat-flat-button (click)="openItemAnnihilatorDialog('0ms', '0ms')">Delete tags</button>
  }

  <div class="tag-manager-page__grid">
    @for (group of groupedTags; track group.letter) {
    <div class="tag-manager-page__letter-group">
      <div class="tag-manager-page__letter-header">{{group.letter}}</div>
      <div class="tag-manager-page__tags-group">
        @for (tag of group.tags; track tag.id) {
        <div class="tag-manager-page__tag-card mat-elevation-z2">
          <div class="tag-manager-page__tag-label">{{tag.label}}</div>
          <div class="tag-manager-page__tag-actions">
            @if (isManager) {
            <button mat-flat-button (click)="openUpdateTagDialog(tag.id,'0ms','0ms')">Update</button>
            <button mat-flat-button (click)="deleteTag(tag)">Delete</button>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
